/** Web shim using browser crypto APIs. */

function toHex(buffer) {
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function randomBytes(size) {
  const bytes = new Uint8Array(size);
  crypto.getRandomValues(bytes);
  return {
    toString(encoding) {
      if (encoding === "hex") {
        return Array.from(bytes)
          .map((b) => b.toString(16).padStart(2, "0"))
          .join("");
      }
      return "";
    },
  };
}

export function createHash(algorithm) {
  const algo = algorithm === "sha256" ? "SHA-256" : algorithm.toUpperCase();
  let data = "";

  return {
    update(chunk) {
      data += String(chunk);
      return this;
    },
    digest(encoding) {
      const encoded = new TextEncoder().encode(data);
      return crypto.subtle.digest(algo, encoded).then((buf) => {
        if (encoding === "hex") return toHex(buf);
        return buf;
      });
    },
  };
}
